import { useFeatureValue } from "@growthbook/growthbook-react";
import { IFeatureValue, IUseVacationPeriod } from "./use-vacation-period.types";
import { GrowthbookFeatures } from "components/growthbook/growthbook.types";
import { useKelasLiveContext } from "stores/kelas-live/kelas-live-context";

const useVacationPeriod = (): IUseVacationPeriod => {
  const { userSubscription } = useKelasLiveContext();
  const featureValue = useFeatureValue<IFeatureValue | null>(
    GrowthbookFeatures.VacationPeriod,
    null
  );

  const subscribedCourseIds =
    userSubscription.subscriptionStatus?.subscribedCourses?.map(
      ({ courseId }) => courseId
    ) || [];

  const showVacationPeriod =
    !!featureValue &&
    (!featureValue.eligible_course_ids ||
      subscribedCourseIds.every(
        (courseId) => !!featureValue.eligible_course_ids?.includes(courseId)
      ));

  const vacationPeriodContent = showVacationPeriod
    ? {
        title: featureValue?.title?.id.replace("\n", "<br />") || "",
        subtitle: featureValue?.subtitle?.id.replace("\n", "<br />") || "",
        bgImg: featureValue?.header_image_web
      }
    : undefined;

  return {
    vacationPeriodContent
  };
};

export default useVacationPeriod;
